// extracted by mini-css-extract-plugin
export var black = "_34-6";
export var brand = "_34-1";
export var ddefault = "_34-0";
export var error = "_34-3";
export var gray = "_34-2";
export var highContrast = "_34-8";
export var outline = "_34-7";
export var success = "_34-5";
export var warning = "_34-4";